import axios from "axios";

export function getAccountsStatistics() {
  return axios.get(process.env.REACT_APP_API_BASE_URL + "accounts-statistics");
}

export function getUnmappedFiles(queryParams) {
  if (queryParams == undefined) {
    return axios.get(
      `${process.env.REACT_APP_API_BASE_URL}unmapped-files/1/10`
    );
  }

  if (
    queryParams.filter.allFields == undefined ||
    queryParams.filter.allFields == ""
  ) {
    return axios.get(
      `${process.env.REACT_APP_API_BASE_URL}unmapped-files/${queryParams.pageNumber}/${queryParams.pageSize}/null/${queryParams.sortField}/${queryParams.sortOrder}`
    );
  } else {
    return axios.get(
      `${process.env.REACT_APP_API_BASE_URL}unmapped-files/${queryParams.pageNumber}/${queryParams.pageSize}/${queryParams.filter.allFields}/${queryParams.sortField}/${queryParams.sortOrder}`
    );
  }
}
export function getUnknownEmailSender(queryParams) {
  if (queryParams == undefined) {
    return axios.get(
      `${process.env.REACT_APP_API_BASE_URL}unknown-email-sender/1/10`
    );
  }

  if (
    queryParams.filter.allFields == undefined ||
    queryParams.filter.allFields == ""
  ) {
    return axios.get(
      `${process.env.REACT_APP_API_BASE_URL}unknown-email-sender/${queryParams.pageNumber}/${queryParams.pageSize}/null/${queryParams.sortField}/${queryParams.sortOrder}`
    );
  } else {
    return axios.get(
      `${process.env.REACT_APP_API_BASE_URL}unknown-email-sender/${queryParams.pageNumber}/${queryParams.pageSize}/${queryParams.filter.allFields}/${queryParams.sortField}/${queryParams.sortOrder}`
    );
  }
}

//fetchUnknownEmailSender
